import MainThreadJob from './MainThreadJob';
import WorkerJob from './WorkerJob';
var JobFactory = /** @class */ (function () {
    function JobFactory() {
    }
    JobFactory.getJob = function (workModule) {
        var _a;
        return ((_a = window) === null || _a === void 0 ? void 0 : _a.Worker) ? new WorkerJob(workModule)
            : new MainThreadJob(workModule);
    };
    return JobFactory;
}());
export default JobFactory;
